var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotemarksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 44,
    viewBox: "0 0 50 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4751_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.16 42.7846V19.0246L35.44 0.304565H49.12L43.36 15.9646H48.76V42.7846H27.16ZM0.880005 42.7846V19.0246L9.16 0.304565H22.84L17.08 15.9646H22.48V42.7846H0.880005Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4751_156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 43,
    fill: "current",
    transform: "translate(0 0.304565)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotemarksIcon);
export default __webpack_public_path__ + "static/media/quotemarks-icon.5a890e45fb06ac372a1620802a63f83f.svg";
export { ForwardRef as ReactComponent };